// extracted by mini-css-extract-plugin
export default {"empty-page-wrapper":"EmptyPage_empty-page-wrapper__x0HdO","message":"EmptyPage_message__2WE0c"};